import FVector from '@data/geometry/FVector';
import { SensorDataManager } from '@data/Simulations/RawSensorDatas';
import { Frame } from './Frame';
import Layer from './Layer';

export class AggregatedFrame extends Frame {
    private sourceFrames: Frame[];

    constructor(parentLayer: Layer, sourceFrames: Frame[], frameName = 'Aggregated') {
        super(parentLayer, frameName, AggregatedFrame.createAggregatedSensorDataManager(sourceFrames));
        this.sourceFrames = sourceFrames;
    }

    public refreshFrames(sourceFrames: Frame[] = this.sourceFrames): void {
        this.sourceFrames = sourceFrames;

        const { scalarValues, vectorialValues } = AggregatedFrame.aggregateFrames(sourceFrames);
        this.forceSensorPointValues(scalarValues, vectorialValues);
        this.updateShadows();
    }

    public getSourceFrames(): Frame[] {
        return this.sourceFrames;
    }

    private static createAggregatedSensorDataManager(sourceFrames: Frame[]): SensorDataManager {
        const { scalarValues, vectorialValues } = AggregatedFrame.aggregateFrames(sourceFrames);
        return new SensorDataManager(new Float32Array(scalarValues), vectorialValues);
    }

    private static aggregateFrames(sourceFrames: Frame[]): { scalarValues: number[]; vectorialValues: FVector[] } {
        const scalarValues: number[] = [];
        const vectorialValues: FVector[] = [];

        sourceFrames.forEach((frame) => {
            frame.getSensors().forEach((sensorData, sensorID) => {
                if (scalarValues[sensorID] == null) scalarValues[sensorID] = 0;
                if (vectorialValues[sensorID] == null) vectorialValues[sensorID] = new FVector();

                scalarValues[sensorID] += sensorData.getScalarValue();
                vectorialValues[sensorID].add(sensorData.getVectorialResult());
            });
        });

        return { scalarValues, vectorialValues };
    }
}
